import type { ReactNode } from "react";

export type TrainBotTabId =
  | "websitePages"
  | "uploadFiles"
  | "addText"
  | "connectApps";

type TrainBotTab = {
  id: TrainBotTabId;
  label: string;
  icon: ReactNode;
};

export const trainBotTabs: TrainBotTab[] = [
  {
    id: "websitePages",
    label: "Website Pages",
    icon: (
      <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
        <path
          d="M1.90758 7C1.44675 6.44583 1.16675 5.73417 1.16675 4.95833C1.16675 3.19667 2.60758 1.75 4.37508 1.75H7.29175C9.05342 1.75 10.5001 3.19667 10.5001 4.95833C10.5001 6.72 9.05925 8.16667 7.29175 8.16667H5.83342"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0925 7.00016C12.5533 7.55433 12.8333 8.266 12.8333 9.04183C12.8333 10.8035 11.3925 12.2502 9.625 12.2502H6.70833C4.94667 12.2502 3.5 10.8035 3.5 9.04183C3.5 7.28016 4.94083 5.8335 6.70833 5.8335H8.16667"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "uploadFiles",
    label: "Upload Files",
    icon: (
      <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
        <path
          d="M5.24992 9.9165V6.4165L4.08325 7.58317"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 6.4165L6.41667 7.58317"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8334 5.83317V8.74984C12.8334 11.6665 11.6667 12.8332 8.75008 12.8332H5.25008C2.33341 12.8332 1.16675 11.6665 1.16675 8.74984V5.24984C1.16675 2.33317 2.33341 1.1665 5.25008 1.1665H8.16675"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8334 5.83317H10.5001C8.75008 5.83317 8.16675 5.24984 8.16675 3.49984V1.1665L12.8334 5.83317Z"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "addText",
    label: "Add Text",
    icon: (
      <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
        <path
          d="M1.55762 4.18274V3.12107C1.55762 2.45024 2.10012 1.91357 2.76512 1.91357H11.2351C11.906 1.91357 12.4426 2.45607 12.4426 3.12107V4.18274"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 12.0866V2.39746"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.70166 12.0864H9.29833"
          stroke="#FB5F66"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "connectApps",
    label: "Connect Apps",
    icon: (
      <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
        <path
          d="M2.91675 5.83317H4.08341C5.25008 5.83317 5.83342 5.24984 5.83342 4.08317V2.9165C5.83342 1.74984 5.25008 1.1665 4.08341 1.1665H2.91675C1.75008 1.1665 1.16675 1.74984 1.16675 2.9165V4.08317C1.16675 5.24984 1.75008 5.83317 2.91675 5.83317Z"
          stroke="#FB5F66"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91675 5.83317H11.0834C12.2501 5.83317 12.8334 5.24984 12.8334 4.08317V2.9165C12.8334 1.74984 12.2501 1.1665 11.0834 1.1665H9.91675C8.75008 1.1665 8.16675 1.74984 8.16675 2.9165V4.08317C8.16675 5.24984 8.75008 5.83317 9.91675 5.83317Z"
          stroke="#FB5F66"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91675 12.8332H11.0834C12.2501 12.8332 12.8334 12.2498 12.8334 11.0832V9.9165C12.8334 8.74984 12.2501 8.1665 11.0834 8.1665H9.91675C8.75008 8.1665 8.16675 8.74984 8.16675 9.9165V11.0832C8.16675 12.2498 8.75008 12.8332 9.91675 12.8332Z"
          stroke="#FB5F66"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.91675 12.8332H4.08341C5.25008 12.8332 5.83342 12.2498 5.83342 11.0832V9.9165C5.83342 8.74984 5.25008 8.1665 4.08341 8.1665H2.91675C1.75008 8.1665 1.16675 8.74984 1.16675 9.9165V11.0832C1.16675 12.2498 1.75008 12.8332 2.91675 12.8332Z"
          stroke="#FB5F66"
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];
